import { Button } from '@dev-spendesk/grapes';
import { useState } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import {
  NotificationType,
  useNotifications,
} from 'src/core/modules/app/notifications';
import { useSetSpanishDprSettings } from 'src/core/modules/bookkeep/apis/useSetSpanishDprSettings';

import { SpanishDprDateSelector } from './SpanishDprDateSelector';

export function SpanishDprSetupEndYearDate() {
  const { t } = useTranslation('global');
  const [selectedMonth, setSelectedMonth] = useState<number | null>(11);
  const [selectedDay, setSelectedDay] = useState<number | null>(31);

  const [updateSpanishDprSettings] = useSetSpanishDprSettings();
  const { pushNotif } = useNotifications();

  const isAvailableToSetValue = selectedMonth !== null && selectedDay !== null;

  const handleSave = async () => {
    if (!isAvailableToSetValue) {
      return;
    }
    await updateSpanishDprSettings({
      fiscalYearEndMonth: selectedMonth,
      fiscalYearEndDay: selectedDay,
    });
    pushNotif({
      type: NotificationType.Success,
      message: t('bookkeep.settings.spanishDpr.setupDate.successNotif'),
    });
  };

  return (
    <>
      <div className="my-24">
        <div>
          <p className="title-m text-content-primary">
            {t('bookkeep.settings.spanishDpr.setupDate.setYearEndDate')}
          </p>
          <p className="body-m text-content-secondary-bg-secondary">
            {t('bookkeep.settings.spanishDpr.editYearEndModal.content')}
          </p>
        </div>
        <SpanishDprDateSelector
          selectedMonth={selectedMonth}
          selectedDay={selectedDay}
          setSelectedMonth={setSelectedMonth}
          setSelectedDay={setSelectedDay}
        />
      </div>

      <Button
        text={t('bookkeep.settings.spanishDpr.setupDate.setYearEndButtonLabel')}
        variant="primaryBrand"
        isDisabled={!isAvailableToSetValue}
        onClick={handleSave}
      />
    </>
  );
}
